export default __webpack_public_path__ + "static/media/pitch_mrror.8b2d4bf0.png";